import axios from "axios";
import Cookies from "js-cookie";
import { getClientServiceRecurrencePayload } from "../helpers/clientServiceRecurrence";
import { normalizeClientServiceInterval } from "../helpers/intervalTypesMap";
import { getFirm } from "./getFirm";
import { FIRMFLOWURL } from "./url";
export const addSubscription = (form, isRenewing = false) => {
    return new Promise(async (resolve) => {
        try {
            const token = Cookies.get("Bearer");
            const firm = await getFirm();
            if (!firm.success) return;
            const normalizedInterval = normalizeClientServiceInterval(
                form.interval,
            );
            const recurrencePayload =
                getClientServiceRecurrencePayload(normalizedInterval);
            const safeForm = { ...form };
            delete safeForm.isEfileStatusActive;

            const response = await axios.post(
                `${FIRMFLOWURL}api/ClientSubscription/firm/${firm.data.id}`,
                {
                    serviceId: safeForm.service_id,
                    serviceYear: safeForm.serviceYear,
                    clientId: safeForm.client_id,
                    clientServiceSubscriptionIntervalType: normalizedInterval,
                    recurrenceType: recurrencePayload.recurrenceType,
                    intervalType: recurrencePayload.intervalType,
                    subscriptionStartDate: safeForm.start,
                    subscriptionEndDate: safeForm.end,
                    //assignedEmployees: form.assignedEmployees,
                    notes: safeForm.notes,
                    temporaryNotes: safeForm.temporaryNotes,
                    assignedById: safeForm.assignedById,
                    lastModifiedById: safeForm.lastModifiedById,
                    assignedEmployee: safeForm.assignedEmployee,
                    isEveryItemRenewable: safeForm.isEveryItemRenewable,
                    isRenewing: isRenewing,
                    teamId: safeForm.teamId,
                },
                {
                    headers: { Authorization: token },
                },
            );
            resolve({ success: true, ...response });
        } catch (err) {
            console.log(err);
            if (err.message.includes(401)) {
                Cookies.remove("Bearer");
                window.location.replace("/");
                return;
            }
            resolve({ success: false, message: err.message });
        }
    });
};
